import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/users/admin/new',
  title: 'Cadastrar Administrador',
  endpoint: '/app/person',
}
